import React from 'react'
import NavBarSecondary from '../../components/Nav/NavBarSecondary'
import NavBarSecondaryMobile from '../../components/Nav/NavBarSecondaryMobile'
import CounterSketchRoutes from './CounterSketchRoutes'
import { FormattedMessage } from 'react-intl'
import { ConfigContext } from '../../App'
import { Box } from '@mui/material'

const CounterSketch = () => {
  const configContext = React.useContext(ConfigContext)
  return (
    <div data-cy='countersketch-container'>
      {configContext.isSmallScreen ? (
        <NavBarSecondaryMobile
          storeURL='/store/countersketch/with-rhinoceros'
          logo='https://gemvision.com/Images/CounterSketch/CounterSketch-Primary-Logo-1-Color-White.svg'
          logoWidth={150}
          logoAlt={'CounterSketch'}
          navBarSecondaryTab={[
            { label: <FormattedMessage id='nav.overview' />, url: '/countersketch', gtmData: 'Countersketch' },
            { label: <FormattedMessage id='nav.gallery' />, url: '/countersketch/gallery', gtmData: 'Gallery' },
            {
              label: <FormattedMessage id='common.releaseNotes' />,
              url: '/countersketch/release-notes',
              gtmData: 'Release_Notes'
            },
            {
              label: <FormattedMessage id='nav.membership' />,
              url: '/countersketch/membership',
              gtmData: 'Membership'
            },
            {
              label: <FormattedMessage id='nav.systemRequirements' />,
              url: '/countersketch/systemrequirements',
              gtmData: 'System_Requirements'
            }
          ]}
        />
      ) : (
        <NavBarSecondary
          storeURL='/store/countersketch/with-rhinoceros'
          indicatorColor='#3f6cb4'
          navBarSecondaryTab={[
            {
              label: (
                <Box
                  component='img'
                  sx={{ height: 13 }}
                  alt='CounterSketch'
                  src={'https://gemvision.com/Images/CounterSketch/CounterSketch-Primary-Logo-1-Color-White.svg'}
                />
              ),
              url: '/countersketch',
              gtmData: 'Countersketch'
            },
            { label: <FormattedMessage id='nav.gallery' />, url: '/countersketch/gallery', gtmData: 'Gallery' },
            {
              label: <FormattedMessage id='common.releaseNotes' />,
              url: '/countersketch/release-notes',
              gtmData: 'Release_Notes'
            },
            {
              label: <FormattedMessage id='nav.membership' />,
              url: '/countersketch/membership',
              gtmData: 'Membership'
            },
            {
              label: <FormattedMessage id='nav.systemRequirements' />,
              url: '/countersketch/systemrequirements',
              gtmData: 'System_Requirements'
            }
          ]}
        />
      )}
      <CounterSketchRoutes />
    </div>
  )
}

export default CounterSketch
